const apiDomain = "https://apps.resnetworld.com/api/";

export const api = {
	login : apiDomain + 'login',
	createHotel : apiDomain + 'newhotel',
	hotelList : apiDomain + 'price-widget/list',
	analytics : apiDomain + 'price-widget/analytics/',
	filter : apiDomain + 'price-widget/analytics/filter'
};
